export const getId = (slug) => {
    const parts = slug.split("-");
    const seriesId = parts[parts.length - 1];
    return seriesId;
  }